import { render } from "./PatientTransferEdit.vue?vue&type=template&id=629bc475"
import script from "./PatientTransferEdit.vue?vue&type=script&lang=js"
export * from "./PatientTransferEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__